import { Route, Routes as RouteSwitch } from 'react-router-dom'
import Goals from '../Goals'
import OnboardingData from '../OnboardingData'
import PostAppointmentNote from '../PostAppointment'
import GoalsV2 from '../Goals-v2'
import LabAppointments from '../LabAppointments'

export const RoutePaths = {
  GOALS: '/goals',
  GOALSV2: '/goals-v2',
  ONBOARDING_DATA: '/onboarding',
  POST_APPOINTMENT_NOTE: '/post-appointment-note',
  LAB_APPOINTMENTS: '/lab-appointments',
}

const Routes: React.FC = () => {
  return (
    <RouteSwitch>
      <Route path={RoutePaths.GOALS} element={<Goals />} />
      <Route path={RoutePaths.GOALSV2} element={<GoalsV2 />} />
      <Route path={RoutePaths.ONBOARDING_DATA} element={<OnboardingData />} />
      <Route
        path={RoutePaths.POST_APPOINTMENT_NOTE}
        element={<PostAppointmentNote />}
      />
      <Route path={RoutePaths.LAB_APPOINTMENTS} element={<LabAppointments />} />
    </RouteSwitch>
  )
}

export default Routes
